var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.694 2.30799C11.102 2.71865 11.102 3.38445 10.694 3.7951L6.52241 8L10.694 12.2049C11.102 12.6156 11.102 13.2814 10.694 13.692C10.286 14.1027 9.62441 14.1027 9.21639 13.692L4.30602 8.74356C3.89799 8.3329 3.89799 7.6671 4.30602 7.25644L9.21639 2.30799C9.62441 1.89734 10.286 1.89734 10.694 2.30799Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.4f854303b053184ebdb4b950227b838c.svg";
export { ForwardRef as ReactComponent };